import { createSubscribableMutator } from '@famly/vet_apollo-utils_create-subscribable-mutator';
import { UpdateLeaveTypeIsPaidMutation } from './update-leave-type-is-paid.mutation';
export const { useSubscribableMutation: useUpdateLeaveTypeIsPaid, useSubscribeMutationResult: useSubscribeUpdateLeaveTypeIsPaidResult, } = createSubscribableMutator(UpdateLeaveTypeIsPaidMutation);
